// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { Logo } from '../logos/Logo'
import * as text from '../text'

export function Product({
  img,
  title,
  description,
  mediaWidth,
  mediaHeight,
}: {
  img: React.Node | string,
  title: React.Node | string,
  description: string,
  mediaWidth?: string,
  mediaHeight?: string,
}) {
  return (
    <StyledProduct>
      {typeof img === 'string' && (
        <img
          src={img}
          alt={description}
          width={mediaWidth}
          height={mediaHeight}
        />
      )}
      {typeof img !== 'string' && img}

      <Wrapper>
        <Title>
          {typeof title === 'string' &&
          ['track', 'plan', 'hire'].includes(title) ? (
            // $FlowFixMe[incompatible-cast] Add %check function.
            <Logo kind={(title: 'hire' | 'plan' | 'track')} dark />
          ) : (
            title
          )}
        </Title>
        <text.P3 color={colors.darkPurple}>{description}</text.P3>
      </Wrapper>
    </StyledProduct>
  )
}

const Title = styled(text.H5)`
  color: ${colors.darkPurple};
  margin-bottom: 5px;
  svg {
    height: 28px;
    margin-top: 8px;
  }
`

const Wrapper = styled.div`
  display: flex;
`

export const ProductsGroup: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  a {
    color: ${colors.darkPurple};
    flex: 1;
  }

  a:not(:last-child) {
    margin-bottom: 20px;
  }

  ${media.mq[1]} {
    flex-direction: row;
    a {
      &:hover img {
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
      }
    }

    a:not(:last-child) {
      margin-bottom: 0;
      margin-right: 20px;
    }
  }

  ${media.mq[2]} {
    a {
      max-width: 350px;
    }
  }
`

const StyledProduct: React.ComponentType<any> = styled.div`
  display: flex;
  & > img {
    width: 40%;
    max-width: 140px;
    height: auto;
    margin-right: 20px;
  }

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    > div:last-child {
      margin-top: 0;
    }
  }

  ${media.mq[1]} {
    display: inline-block;
    width: 100%;

    & > img {
      width: 100%;
      max-width: none;
      margin-right: 0;
      padding: 8px;
      background: ${colors.almostWhite};
      box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
      transition: 0.5s ease;
    }

    & > div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 0;
      margin-top: 16px;

      & > span {
        margin-top: 10px;
      }
    }
  }
`
